import styled, { css } from "styled-components";
import { ThemeType } from "../../../types/Theme";

const commonStyles = css`
  width: 100rem;
  max-width: 90vw;
  margin-top: 5rem;

  > .containerFlex {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    > .texto {
      width: 90%;
      margin-bottom: 2rem;
      color: ${(props) => props.theme.colors.tertiary};
    }

    > .containerToggles {
      margin-bottom: 4rem;
      > .containerToggle {
        position: relative;
        padding: 2rem 0;
        &:not(:last-child) {
          &::after {
            content: "";
            position: absolute;
            bottom: 0;
            width: 40rem;
            height: 2px;
            left: 0;
            right: 0;
            margin-left: auto;
            margin-right: auto;
            background-color: ${(props) => props.theme.colors.elements};
            border-radius: 50px;
          }
        }
      }
    }

    .toggles {
      display: flex;
      gap: 2rem;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .containerToggleConfigurar {
        .nome {
          color: ${(props) => props.theme.colors.tertiary};
        }
      }
    }
  }
`;

export const ContainerPedidosConfigsContainer = styled.div<{
  configIn: "empresa" | "configuracoes";
  theme: ThemeType;
}>`
  ${commonStyles}
  ${({ configIn, theme }) =>
    configIn === "configuracoes" &&
    css`
      width: 100%;

      .titulo-secao {
        width: 100%;
        text-align: left;
        font-weight: 700;
        color: ${theme.colors.tertiary};
        margin-bottom: 1rem;
      }
      > .containerFlex {
        > .texto {
          width: 100%;
          text-align: left;
          margin: 0;
        }
        .containerToggles {
          padding-top: 8px;
          width: 100%;
          > .containerToggle {
            width: 100%;
            padding: 0;
            &::after {
              display: none;
            }
            .containerToggleConfigurar {
              width: 100%;
              .nome {
                width: 100%;
                color: ${(props) => props.theme.colors.tertiary};
                font-weight: bold;
              }
            }
            .hidden {
              display: block !important;
              visibility: hidden;
              pointer-events: none;
            }
          }
        }
      }
    `}
`;

// Add other styled components for the nested elements if necessary

export const ContainerNumeracaoPedidos = styled.div<{ theme: ThemeType }>`
  width: 100%;
  text-align: left;
  color: ${(props) => props.theme.colors.tertiary};
  margin-bottom: 4rem;

  .toggleContainer {
    margin-top: 2rem;
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.colors.tertiary};
    gap: 1rem;

    span {
      text-align: justify;
    }
  }

  .bloco-input {
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;

    .label-numero {
      color: ${(props) => props.theme.colors.tertiary};
    }

    .campo-numero {
      width: 35%;

      @media (max-width: 768px) {
        width: 100%;
      }
    }
  }

  .aviso {
    margin-top: 1rem;
    opacity: 0.8;
  }
`;
